import { useContext } from 'react';
import { TrendDrawerContext } from '../TrendProvider';

const useDrawerContext = () => {
  const value = useContext(TrendDrawerContext);
  if (!value) {
    throw new Error(
      'useDrawerContext hook should be used in a context of DrawerContextProvider component.',
    );
  }
  return value;
};
export default useDrawerContext;
